if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
     if( this.form.querySelector('[name="id"]')){
      this.form.querySelector('[name="id"]').disabled= false;
}
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    //  this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      console.log("gzzz");
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
     // this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
    //  formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
  //         console.log("I am hereeeee");
  //                   gtag('event', 'conversion', {
  //             'allow_custom_scripts': true,
  //             'u10': 'New',
  //             'u11': response?.vendor,
  //             'u2': response?.sku,
  //             'u3':  response?.title,
  //             'u4': response?.product_type,
  //             'u5':  Number(response?.price / 100),
  //             'send_to': 'DC-12473326/gener0/darts001+standard'
  //           });   

                   
  //                     fbq('track', 'AddToCart', {
  //           product_category: response?.vendor, 
  //           product_name: response?.title, 
  //           price:  Number(response?.price / 100), 
  //           content_type: "product",
  //           content_ids: response?.sku
          
  //           });
          // API endpoint
var url = `https://api.reviews.co.uk/product/review?store=www.dartscorner.co.uk&sku=${response?.sku}`;

// Using fetch to make the GET request
fetch(url)
    .then(response => {
        // Check if the response is ok (status 200)
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json(); // Parse JSON response
    })
    .then(data => {

      window.dataLayer.push({ ecommerce: null });
          console.log("just check this log");
          console.log(response);
window.dataLayer.push({
  event: 'add_to_cart',
  ecommerce: {
    currency: window.currencysignCustom,
    value: Number(response?.price / 100),
    items: [{
      item_name:  response?.product_title,
      item_id: response?.sku,
      price:  Number(response?.price / 100),
      item_brand: response?.vendor,
      item_category: response?.product_type,
      item_reviews: data.stats.count,
      item_review_rating: Number(data.stats?.average),
      item_variant: response?.variant_title,
      in_stock: "yes",
      on_offer: response.total_discount != 0 ? "yes":"no",
      index: 0,
      quantity: response.quantity
}]
  }
});
      console.log("just check this log");
      console.log(window.dataLayer);
  
    })
    .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
    });
           gtag('event', 'conversion', {
      'send_to': 'AW-1070557501/M98ECOnNzOYYEL3Svf4D',
      'value': Number(response?.price / 100)  
      
    });

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
             // setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
          //  this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          console.log("I am hereeeee");
        })
        .finally(() => {
          console.log("I am hereeeee");
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
  
}


if (!customElements.get('product-form-pers')) {
  customElements.define('product-form-pers', class ProductForm1 extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('.form-pers');
      let _this =this;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    //  this.cartNotification = document.querySelector('cart-notification');
    // this.submitButton = this.querySelector('.product-pers');
    //    this.submitButton.addEventListener("click", function(e){
    //      console.log("herezz");
           
    //    });

    }

  

    onSubmitHandler(evt) {
      evt.preventDefault();
     // if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
     // this.cartNotification.setActiveElement(document.activeElement);

     // this.submitButton.setAttribute('aria-disabled', true);
     // this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var matchemoji = false;
      $(".pers_in_field").each(function(){
	   const productinputval = $(this).val();
	   var ranges = ['(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])'];
         if (productinputval.match(ranges.join('|'))) {
		 var matchemoji = true;
         $(this).val('');
         $(this).next(".emojierror").show();
         setTimeout(function() {
         $("body").removeClass("cart-drawer-open");
         $(".cart-drawer").css("transform","translateX(100%)");
         },800);
      }
	  else{
	  $(this).next(".emojierror").hide();
      $("body").addClass("cart-drawer-open");
      $(".cart-drawer").css("transform","translateX(0px)")  
	  }
	  });
      if(matchemoji == true){
      }
      else{
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const formData = new FormData(this.form);
      for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]); 
      }
      var productAdded = {};
    //  formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
           productAdded = response;
          if (response.status) {
            this.handleErrorMessage(response.description);

           // const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
           // this.submitButton.setAttribute('aria-disabled', true);
           // this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
             // setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
          //  this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
         // this.submitButton.classList.remove('loading');
         // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
           if(document.querySelector('[name="back-print"]')?.checked){
           
          
            if(document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked')?.value == "Yes"){
              var dataforAddition ={items:[{id:41828991795382,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku,additionDiscount:"true"}}]};

            }else {
              var dataforAddition ={items:[{id:41828991795382,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

            }

            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              async: false,
              data:dataforAddition,
              success: (response)=>{
              


             
                
              
              },
              error: ()=>{}
           });
          
         
    
          }

          if(document.querySelector('[name="left-pocket"]')?.checked){
            if(document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked')?.value == "Yes"){
              var dataforAddition ={items:[{id:41830646120630,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku,additionDiscount:"true"}}]};

            }else {
              var dataforAddition ={items:[{id:41830646120630,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

            }
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              async: false,
              data:dataforAddition,
              success: (response)=>{
                
             
                
              
              },
              error: ()=>{}
           });
          
         
    
          }


          if(document.querySelector('[name="right-pocket"]')?.checked){
            if(document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked')?.value == "Yes"){
              var dataforAddition ={items:[{id:41830646153398,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku,additionDiscount:"true"}}]};

            }else {
              var dataforAddition ={items:[{id:41830646153398,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

            }
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              async: false,
              data:dataforAddition,
              success: (response)=>{
              


             
                
              
              },
              error: ()=>{}
           });
          
         
    
          }

          if(document.querySelector('[name="collar"]')?.checked){
                setTimeout(function(){ 

                   console.log("we hazddd");
            if(document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked')?.value == "Yes"){
              var dataforAddition ={items:[{id:41830646186166,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku,additionDiscount:"true"}}]};

            }else {
              var dataforAddition ={items:[{id:41830646186166,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

            }
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data:dataforAddition,
              success: (response)=>{
               

             
                
              
              },
              error: ()=>{}
           });
var loaderSkeleton = document.querySelector('.loader__skeleton');
                   loaderSkeleton.style.display = 'block';
  fetch('/?view=cart-drawer')
    .then(function (response) {
      return response.text();
    })
    .then(function (cartData) {
      document.querySelector('.cart-drawer__body').innerHTML = cartData;
      loaderSkeleton.style.display = 'none';
    });

                  

                     },1500)
           
    
          }

          if(document.querySelector('[name="left-arm"]')?.checked){
            if(document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked')?.value == "Yes"){
              var dataforAddition ={items:[{id:41831131283638,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku,additionDiscount:"true"}}]};

            }else {
              var dataforAddition ={items:[{id:41831131283638,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

            }
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data:dataforAddition,
              success: (response)=>{
           
             
                
              
              },
              error: ()=>{}
           });
          
         
    
          }

          if(document.querySelector('[name="right-arm"]')?.checked){
            setTimeout(function(){
              if(document.querySelector('input[name="properties[Darts_Corner_Logo]"]:checked')?.value == "Yes"){
              var dataforAddition ={items:[{id:41831131316406,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku,additionDiscount:"true"}}]};

            }else {
              var dataforAddition ={items:[{id:41831131316406,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

            }
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data:dataforAddition,
              success: (response)=>{
              


             
                
              
              },
              error: ()=>{}
           });
          
            },1000)
            
         
    
          }


          if(document.querySelector('[name="1PERSLASER"]')?.checked){
           
          var dataforAddition ={items:[{id:41830983205046,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};

        
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data:dataforAddition,
              success: (response)=>{
                 },
              error: ()=>{}
           });
          
         
    
          }

          if(document.querySelector('[name="properties[Shafts_Laser_Engraved]"]:checked')?.value == "One Side Only" || document.querySelector('[name="properties[Shafts_Laser_Engraved_enhanced]"]:checked')?.value == "One Side Only"){
           
            var dataforAddition ={items:[{id:41831041630390,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
  
          
              $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data:dataforAddition,
                success: (response)=>{
                 
  
  
               
                  
                
                },
                error: ()=>{}
             });
            
           
      
            }


            if(document.querySelector('[name="properties[Shafts_Laser_Engraved]"]:checked')?.value == "Two Sides"){
           
              var dataforAddition ={items:[{id:41831041663158,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
    
            
                $.ajax({
                  type: 'POST', 
                  url: '/cart/add.js',
                  dataType: 'json', 
                  data:dataforAddition,
                  success: (response)=>{
                   
                 
                    
                  
                  },
                  error: ()=>{}
               });
              
             
        
              }

            if(document.querySelector('[name="properties[Printing_Area]"]:checked')?.value == "Simple_Print_Top_Area_Only" || document.querySelector('[name="properties[Printing_Area]"]:checked')?.value == "Simple_Print_Bottom_Area_Only" || document.querySelector('[name="properties[Printing_Area]"]:checked')?.value == "Simple_Print_Top_and_Bottom_Areas"){
           
              var dataforAddition ={items:[{id:41855502319798,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
    
            
                $.ajax({
                  type: 'POST', 
                  url: '/cart/add.js',
                  dataType: 'json', 
                  data:dataforAddition,
                  success: (response)=>{
                   
                 
                    
                  
                  },
                  error: ()=>{}
               });
              
             
        
              }

            if(document.querySelector('[name="properties[Personalize_Printing_Area]"]:checked')?.value == "Print Top Area Only" || document.querySelector('[name="properties[Personalize_Printing_Area]"]:checked')?.value == "Print Bottom Area Only" || document.querySelector('[name="properties[Personalize_Printing_Area]"]:checked')?.value == "Print Top and Bottom Areas"){
           
              var dataforAddition ={items:[{id:41855502352566,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
    
            
                $.ajax({
                  type: 'POST', 
                  url: '/cart/add.js',
                  dataType: 'json', 
                  data:dataforAddition,
                  success: (response)=>{
                   
                 
                    
                  
                  },
                  error: ()=>{}
               });
              
             
        
              }
          
            if(document.querySelector('[name="properties[Case_Printing_Area]"]:checked')?.value == "Print Top Area Only" || document.querySelector('[name="properties[Case_Printing_Area]"]:checked')?.value == "Print Bottom Area Only" ){
           
              var dataforAddition ={items:[{id:41855601180854,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
    
            
                $.ajax({
                  type: 'POST', 
                  url: '/cart/add.js',
                  dataType: 'json', 
                  data:dataforAddition,
                  success: (response)=>{
                   
                 
                    
                  
                  },
                  error: ()=>{}
               });
              
             
        
              }

             if(document.querySelector('[name="properties[Case_Printing_Area]"]:checked')?.value == "Print Top and Bottom Areas"  ){
           
              var dataforAddition ={items:[{id:41855601213622,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
    
            
                $.ajax({
                  type: 'POST', 
                  url: '/cart/add.js',
                  dataType: 'json', 
                  data:dataforAddition,
                  success: (response)=>{
                   
                 
                    
                  
                  },
                  error: ()=>{}
               });
              
             
        
              }

          

              
            if(document.querySelector('[name="properties[Shafts_Laser_Engraved_enhanced]"]:checked')?.value == "Two Sides"){
           
              var dataforAddition ={items:[{id:41831361151158,quantity:$("quantity-input .quantity__input").val(),properties:{forProduct:productAdded.sku}}]};
    
            
                $.ajax({
                  type: 'POST', 
                  url: '/cart/add.js',
                  dataType: 'json', 
                  data:dataforAddition,
                  success: (response)=>{
                  
                 
                    
                  
                  },
                  error: ()=>{}
               });
              
             
        
              }
          
        });

	}
    
      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    displayDate(e) {
      console.log("me clicked");
    }
    
  });
}